import { render, staticRenderFns } from "./TicketsMonitoring.vue?vue&type=template&id=2d3c2bee&scoped=true"
import script from "./TicketsMonitoring.vue?vue&type=script&lang=js"
export * from "./TicketsMonitoring.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2d3c2bee",
  null
  
)

export default component.exports